(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifPanel', swifPanel);


    /**
        * @ngdoc directive
        * @name swif.ui:swifPanel
        * @module swif.ui
        * @restrict E
        * @description dynamic panel wrapper based in the content type (found in object._type)
        * @element swif-panel
        * @usage
            <swif-panel ng-model="model"></swif-panel>

    **/
    function swifPanel($compile) {
        'ngInject';
        var template = '<div></div>';
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            require: 'ngModel',
            scope: {},
            link: function (scope, element, attrs, ngModel, transcludeFn) {
                var linked = element.find('.panel').length > 0;
                var vvtype;
                transcludeFn(scope, function(nodes) {
                    element.find('.tranclude').empty();
                    element.find('.tranclude').append(nodes);
                });
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    if (vv) {
                        if (vvtype !== vv._type) {
                            vvtype = vv._type;
                            if (vvtype) {
                                if (_.contains(vvtype, '_')) {
                                    vvtype = vvtype.replace(/_/g, '-');
                                }
                            }
                        }
                        scope.proxy = vv;
                        if (!linked) {
                            var html = '<div panel-' + vvtype +' ng-model="proxy"><span class="transclude">{{proxy.name}}</span></div>';
                            var template = angular.element(html);
                            var linkFn = $compile(template);
                            var pelement = linkFn(scope);

                            //element.find('.panel').remove();
                            element.append(pelement);
                            setTimeout(function () {
                                element.find('.panel').addClass(attrs.class);
                            }, 200);
                            linked = true;
                        }
                    }
                };
            },
            template: template
        };
    }

})();
